import os from 'os';

/**
 * System metadata structure matching server schema
 */
export interface SystemMetadata {
  hostname: string;
  cpu: {
    count: number;
    model: string;
  };
  memory: {
    total: string;
  };
  os: string;
  nodejs: string;
  playwright: string;
}

/**
 * Collector for system metadata
 */
export class SystemCollector {
  /**
   * Gather system metadata
   */
  static collect(): SystemMetadata {
    const hostname = os.hostname() || 'unknown';

    const cpus = os.cpus();
    const cpuCount = cpus.length || 0;
    const cpuModel = cpus[0]?.model || 'unknown';

    const totalMemBytes = os.totalmem();
    const totalMemGB = Math.round(totalMemBytes / 1024 ** 3);
    const memoryTotal = totalMemBytes > 0 ? `${totalMemGB} GB` : 'unknown';

    const osInfo = `${os.type()} ${os.release()}`;
    const nodeVersion = process.version || 'unknown';

    let playwrightVersion = 'unknown';
    try {
      // Attempt to read Playwright version from package
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      const pkg = require('playwright/package.json');
      playwrightVersion = pkg.version || 'unknown';
    } catch {
      // Try alternative paths for Playwright version
      try {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const pkg = require('@playwright/test/package.json');
        playwrightVersion = pkg.version || 'unknown';
      } catch {
        // Keep default 'unknown'
      }
    }

    return {
      hostname,
      cpu: {
        count: cpuCount,
        model: cpuModel,
      },
      memory: {
        total: memoryTotal,
      },
      os: osInfo,
      nodejs: nodeVersion,
      playwright: playwrightVersion,
    };
  }
}
